import installationInstructions from './installationInstructions';

const pehCamContent = {
  installationInstructions
}

export { pehCamContent };
